import React from "react";
import { Link } from "react-router-dom";
import "./About.css";

const PrivacyPolicy = () => {
    return (
        <section className="privacy-policy-page">
            <div className="about-card privacy-policy-inner">
                <h1>Privacy Policy</h1>
                <p className="About-subtitle">Effective Date: April 2026</p>

                <p className="About-text">Park Pilot provides valet operations support and customer vehicle status notifications. This Privacy Policy explains what information we collect, how we use it, and your choices.</p>

                <h2>1. Information We Collect</h2>
                <p className="About-text">We collect only information needed to operate valet services, including: customer mobile number, ticket number, basic vehicle details (for example make/color), and service activity records (check-in, status updates, and related timestamps).</p>

                <h2>2. How We Use Information</h2>
                <p className="About-text">We use collected information only to operate valet services during the course of valet operations, including vehicle tracking, service updates, and customer support.</p>

                <h2>3. SMS Communications</h2>
                <p className="About-text">We send SMS messages for transactional service purposes only (for example vehicle check-in/status updates). Message frequency varies by service activity. Message and data rates may apply.</p>

                <h2>4. Consent, Opt-Out, and Help</h2>
                <p className="About-text">By providing a mobile number for valet service updates, users consent to receive transactional SMS messages. Users may opt out at any time by replying STOP. For assistance, reply HELP.</p>

                <h2>5. Data Sharing and Marketing</h2>
                <p className="About-text">We do not sell personal information. We do not share customer data with third parties, affiliates, or partners for their marketing or promotional purposes.</p>
                <p className="About-text">All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties, affiliates, or partners for marketing or promotional purposes.</p>

                <h2>6. Service Providers</h2>
                <p className="About-text">We may use service providers only as necessary to deliver valet operations and SMS messaging (for example, communications platform providers).</p>

                <h2>7. Data Retention</h2>
                <p className="About-text">We retain information only as needed for valet operational records, troubleshooting, and legitimate business or legal requirements.</p>

                <h2>8. Security</h2>
                <p className="About-text">We apply reasonable administrative and technical safeguards to protect information used in our valet operations.</p>

                <h2>9. Contact</h2>
                <p className="About-text">For privacy questions, contact: support@parkpilot.com</p>

                <p className="About-text">
                    <Link to="/privacy-sms-policy">View SMS Privacy Policy</Link>
                </p>
                <p className="About-text">
                    <Link to="/terms">View SMS Terms & Conditions</Link>
                </p>
                <p className="About-text">
                    <Link to="/">Back to Home</Link>
                </p>
            </div>
        </section>
    );
};

export default PrivacyPolicy;
